import { render, staticRenderFns } from "./InventoryEditDrawer.vue?vue&type=template&id=fc8963e4&scoped=true&"
import script from "./InventoryEditDrawer.vue?vue&type=script&lang=js&"
export * from "./InventoryEditDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InventoryEditDrawer.vue?vue&type=style&index=0&id=fc8963e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8963e4",
  null
  
)

export default component.exports